module.exports = __webpack_public_path__ + "static/img/header.76517a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header.svg
// module id = v8Uc
// module chunks = 0